/* Shelf theme: lightweight vanilla JS (no dependencies). */
(function () {
  'use strict';

  const T = window.theme || {};
  const R = T.routes || {};
  const S = T.strings || {};
  const qs = (sel, ctx) => (ctx || document).querySelector(sel);
  const qsa = (sel, ctx) => Array.prototype.slice.call((ctx || document).querySelectorAll(sel));

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(message, isError) {
    const el = qs('[data-toast]');
    if (!el) return;
    el.textContent = message;
    el.className = 'toast is-visible' + (isError ? ' toast--error' : '');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 3500);
  }

  /* ---------- Cart count ---------- */
  function updateCount(count) {
    qsa('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = !(count > 0);
    });
  }

  /* ---------- Cart drawer ---------- */
  let lastFocus = null;
  const drawerEl = () => qs('[data-cart-drawer]');

  function openDrawer() {
    const d = drawerEl();
    if (!d) return false;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('no-scroll');
    const panel = qs('.drawer__panel', d);
    if (panel) panel.focus();
    return true;
  }

  function closeDrawer() {
    const d = drawerEl();
    if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('no-scroll');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function refreshDrawer() {
    return fetch(R.root + '?sections=cart-drawer', { headers: { Accept: 'application/json' } })
      .then((res) => res.json())
      .then((data) => {
        const html = data && data['cart-drawer'];
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const next = qs('[data-cart-drawer-inner]', doc);
        const cur = qs('[data-cart-drawer-inner]');
        if (next && cur) {
          cur.innerHTML = next.innerHTML;
          cur.setAttribute('data-item-count', next.getAttribute('data-item-count'));
          updateCount(Number(next.getAttribute('data-item-count')) || 0);
        }
      });
  }

  function changeLine(line, quantity) {
    const inner = qs('[data-cart-drawer-inner]');
    if (inner) inner.style.opacity = '.55';
    return fetch(R.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    })
      .then((res) => res.json())
      .then((cart) => {
        if (cart.status && cart.description) toast(cart.description, true);
        return refreshDrawer();
      })
      .catch(() => toast(S.error, true))
      .then(() => { if (inner) inner.style.opacity = ''; });
  }

  /* ---------- Add to cart / Buy now ---------- */
  function setLoading(form, on) {
    qsa('button[type="submit"]', form).forEach((b) => {
      b.classList.toggle('is-loading', on);
      if (on) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
    });
  }

  function showFormError(form, message) {
    const el = qs('[data-form-error]', form);
    if (el) {
      el.textContent = message;
      el.hidden = !message;
    } else if (message) {
      toast(message, true);
    }
  }

  function addToCart(form, buyNow) {
    if (form._busy) return;
    form._busy = true;
    showFormError(form, '');
    setLoading(form, true);
    const body = new FormData(form);
    let redirecting = false;
    const request = {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: body
    };
    // Bump offer ticked: add the product and the bump product together.
    const section = form.closest('[data-product-section]');
    const bump = section && qs('[data-bump-input]', section);
    if (bump && bump.checked) {
      const items = [{ id: Number(body.get('id')), quantity: Math.max(1, Number(body.get('quantity')) || 1) }];
      items.push({ id: Number(bump.getAttribute('data-bump-variant')), quantity: 1 });
      request.headers['Content-Type'] = 'application/json';
      request.body = JSON.stringify({ items: items });
    }

    fetch(R.cartAdd + '.js', request)
      .then((res) => res.json().then((data) => ({ ok: res.ok, data: data })))
      .then((r) => {
        if (!r.ok || r.data.status) {
          throw new Error(r.data.description || r.data.message || S.error);
        }
        if (buyNow) {
          redirecting = true;
          window.location.href = R.checkout;
          return null;
        }
        if (T.hasDrawer && drawerEl()) {
          return refreshDrawer().then(() => { openDrawer(); });
        }
        redirecting = true;
        window.location.href = R.cart;
        return null;
      })
      .catch((err) => {
        showFormError(form, err && err.message ? err.message : S.error);
      })
      .then(() => {
        form._busy = false;
        if (!redirecting) setLoading(form, false);
      });
  }

  /* ---------- Global delegated events ---------- */
  document.addEventListener('click', (e) => {
    const t = e.target;
    if (!t || !t.closest) return;

    const buy = t.closest('[data-buy-now]');
    if (buy) {
      const form = buy.closest('form[data-product-form]');
      if (form) {
        e.preventDefault();
        addToCart(form, true);
      }
      return;
    }

    const open = t.closest('[data-cart-open]');
    if (open && T.hasDrawer && drawerEl()) {
      e.preventDefault();
      openDrawer();
      refreshDrawer();
      return;
    }

    if (t.closest('[data-drawer-close]')) {
      closeDrawer();
      return;
    }

    const remove = t.closest('[data-remove-line]');
    if (remove) {
      changeLine(remove.getAttribute('data-remove-line'), 0);
      return;
    }

    const step = t.closest('[data-qty-step]');
    if (step) {
      const wrap = step.closest('[data-qty]');
      const input = wrap && qs('input', wrap);
      if (input) {
        const min = Number(input.min || 0);
        const next = Math.max(min, (Number(input.value) || 0) + Number(step.getAttribute('data-qty-step')));
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    const share = t.closest('[data-share]');
    if (share) {
      const url = share.getAttribute('data-share');
      if (navigator.share) {
        navigator.share({ url: url }).catch(() => {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(() => toast(S.copied));
      }
    }
  });

  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (form && form.matches && form.matches('form[data-product-form]')) {
      e.preventDefault();
      addToCart(form, false);
    }
  });

  document.addEventListener('change', (e) => {
    const t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('[data-drawer-qty-input]')) {
      changeLine(t.getAttribute('data-line'), Math.max(0, Number(t.value) || 0));
    } else if (t.matches('[data-cart-qty-input]') && t.form) {
      t.form.submit();
    } else if (t.matches('[data-auto-submit]') && t.form) {
      t.form.submit();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeDrawer();
      qsa('details[data-mobile-menu][open], details[data-search-modal][open]').forEach((d) => { d.open = false; });
    }
    if (e.key === 'Tab') {
      const d = drawerEl();
      if (d && d.classList.contains('is-open')) {
        const items = qsa('a[href], button:not([disabled]), input:not([disabled])', qs('.drawer__panel', d)).filter((el) => el.offsetParent !== null);
        if (!items.length) return;
        const first = items[0];
        const last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
  });

  /* ---------- Header ---------- */
  function initHeader() {
    qsa('.header--sticky, .announcement--sticky').forEach((el) => {
      const wrap = el.closest('.shopify-section');
      if (wrap) wrap.classList.add('is-sticky-wrapper');
    });
    const search = qs('[data-search-modal]');
    if (search && !search._init) {
      search._init = true;
      search.addEventListener('toggle', () => {
        if (search.open) {
          const input = qs('input[type="search"]', search);
          if (input) input.focus();
        }
      });
    }
    const menu = qs('[data-mobile-menu]');
    if (menu && !menu._init) {
      menu._init = true;
      window.addEventListener('resize', () => { if (window.innerWidth >= 990) menu.open = false; });
    }
    const recover = qs('details#recover');
    if (recover && window.location.hash === '#recover') recover.open = true;
  }

  /* ---------- Announcement bar: always one line, rotating ---------- */
  function fitAnnouncement() {
    qsa('.announcement__item').forEach((el) => {
      el.style.fontSize = '';
      let size = parseFloat(window.getComputedStyle(el).fontSize) || 13.6;
      while (el.scrollWidth > el.clientWidth + 1 && size > 10.5) {
        size -= 0.5;
        el.style.fontSize = size + 'px';
      }
    });
  }

  let fitTimer;
  window.addEventListener('resize', () => { clearTimeout(fitTimer); fitTimer = setTimeout(fitAnnouncement, 120); });

  function initAnnouncement() {
    const bar = qs('[data-announcement]');
    if (!bar) return;
    fitAnnouncement();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAnnouncement);
    if (bar._init) return;
    bar._init = true;
    const items = qsa('.announcement__item', bar);
    // While a timer message is running it is the only message shown; the others come back when it ends.
    const pool = () => {
      const timers = items.filter((it) => !it.hidden && !it.classList.contains('is-ended') && it.classList.contains('announcement__item--timer'));
      return timers.length ? timers : items.filter((it) => !it.hidden);
    };
    const activate = (item) => {
      items.forEach((it) => it.classList.remove('is-active'));
      if (item) item.classList.add('is-active');
    };
    let current = null;
    const refresh = () => {
      const list = pool();
      bar.hidden = !list.length;
      if (!list.length) return;
      if (list.indexOf(current) === -1) current = list[0];
      activate(current);
    };
    qs('.announcement__inner', bar).classList.add('is-rotating');
    refresh();
    bar.addEventListener('timer:end', refresh);
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    setInterval(() => {
      const list = pool();
      if (list.length < 2) { refresh(); return; }
      current = list[(list.indexOf(current) + 1) % list.length];
      activate(current);
    }, 5000);
  }

  /* ---------- Star rating link -> reviews section ---------- */
  function initReviewsLink() {
    const target = qs('[data-reviews-section]');
    if (target && !target.id) target.id = 'reviews';
    qsa('[data-reviews-link]').forEach((link) => {
      if (link._init) return;
      link._init = true;
      if (!target) {
        link.classList.add('is-static');
        link.removeAttribute('href');
        link.removeAttribute('aria-label');
        return;
      }
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        if (window.history && window.history.replaceState) window.history.replaceState(null, '', '#reviews');
      });
    });
  }

  /* ---------- Product page ---------- */
  function initProduct(root) {
    if (root._init) return;
    const jsonEl = qs('[data-product-json]', root);
    if (!jsonEl) return;
    let data;
    try { data = JSON.parse(jsonEl.textContent); } catch (err) { return; }
    root._init = true;

    const picker = qs('[data-variant-picker]', root);
    const idInput = qs('[data-variant-id]', root);
    const priceWrap = qs('[data-price]', root);
    const stickyPrice = qs('[data-sticky-price]', root);
    const buyBtn = qs('[data-buy-now]', root);
    const atcBtn = qs('[data-atc]', root);
    const stickyBtn = qs('[data-sticky-trigger]', root);
    const buyLabel = qs('[data-buy-label]', root);
    const stickyLabel = qs('[data-sticky-label]', root);
    const bumpInput = qs('[data-bump-input]', root);
    const viewport = qs('[data-gallery-viewport]', root);
    const slides = qsa('.gallery__slide[data-media-id]', root);
    const thumbs = qsa('[data-thumb]', root);

    function scrollToIndex(idx) {
      if (!viewport) return;
      viewport.scrollTo({ left: idx * viewport.clientWidth, behavior: 'smooth' });
    }

    function setActiveThumb(idx) {
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === idx));
    }

    thumbs.forEach((t, i) => t.addEventListener('click', () => scrollToIndex(i)));

    function stepGallery(delta) {
      if (!viewport || slides.length < 2) return;
      const current = Math.round(viewport.scrollLeft / (viewport.clientWidth || 1));
      scrollToIndex((current + delta + slides.length) % slides.length);
    }
    const prevBtn = qs('[data-gallery-prev]', root);
    const nextBtn = qs('[data-gallery-next]', root);
    if (prevBtn) prevBtn.addEventListener('click', () => stepGallery(-1));
    if (nextBtn) nextBtn.addEventListener('click', () => stepGallery(1));

    if (viewport && thumbs.length) {
      let raf;
      viewport.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          setActiveThumb(Math.round(viewport.scrollLeft / (viewport.clientWidth || 1)));
        });
      }, { passive: true });
    }

    function selectedOptions() {
      const opts = [];
      if (!picker) return opts;
      qsa('fieldset[data-option-index]', picker).forEach((fs) => {
        const checked = qs('input:checked', fs);
        opts[Number(fs.getAttribute('data-option-index'))] = checked ? checked.value : null;
      });
      return opts;
    }

    function findVariant(opts) {
      return data.variants.filter((v) => v.options.every((o, i) => o === opts[i]))[0];
    }

    function fillLabel(el, available, variant) {
      if (!el) return;
      const tpl = el.getAttribute('data-template') || S.buyNow || '';
      const sold = el.getAttribute('data-sold-out') || S.soldOut;
      if (!variant) { el.textContent = S.unavailable; return; }
      const total = bumpInput && bumpInput.checked && variant.bumpTotalText ? variant.bumpTotalText : variant.priceText;
      el.textContent = available ? tpl.split('{price}').join(total) : sold;
    }

    function setButtons(variant) {
      const available = !!(variant && variant.available);
      [buyBtn, atcBtn, stickyBtn].forEach((b) => { if (b) b.disabled = !available; });
      fillLabel(buyLabel, available, variant);
      fillLabel(stickyLabel, available, variant);
    }

    function onVariantChange() {
      const variant = findVariant(selectedOptions());
      setButtons(variant);
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceWrap) priceWrap.innerHTML = variant.priceHtml;
      if (stickyPrice) stickyPrice.innerHTML = variant.priceHtml;
      if (window.history && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      if (variant.mediaId) {
        const idx = slides.findIndex((s) => Number(s.getAttribute('data-media-id')) === variant.mediaId);
        if (idx > -1) { scrollToIndex(idx); setActiveThumb(idx); }
      }
    }

    if (picker) picker.addEventListener('change', onVariantChange);

    // Bump offer: the Buy button shows the total of both products.
    function currentVariant() {
      return data.variants.filter((v) => String(v.id) === String(idInput ? idInput.value : ''))[0];
    }
    if (bumpInput) {
      const refreshTotal = () => { const v = currentVariant(); if (v) setButtons(v); };
      bumpInput.addEventListener('change', refreshTotal);
      refreshTotal();
    }

    /* Sticky mobile buy bar */
    const sticky = qs('[data-sticky-buy]', root);
    if (sticky && buyBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        const visible = !entries[0].isIntersecting;
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
        if (stickyBtn) stickyBtn.tabIndex = visible ? 0 : -1;
      }, { threshold: 0 }).observe(buyBtn);
    }
    if (stickyBtn && buyBtn) stickyBtn.addEventListener('click', () => buyBtn.click());
  }

  /* ---------- Related products (Section Rendering API) ---------- */
  function initRecommendations() {
    qsa('[data-recommendations]').forEach((el) => {
      if (el._init || !el.hasAttribute('hidden')) return;
      const url = el.getAttribute('data-url');
      if (!url) return;
      el._init = true;
      fetch(url)
        .then((res) => res.text())
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const rec = qs('[data-recommendations]', doc);
          if (rec && rec.querySelector('.grid__item')) {
            el.innerHTML = rec.innerHTML;
            el.hidden = false;
          }
        })
        .catch(() => {});
    });
  }

  /* ---------- Product carousel ---------- */
  function initCarousels() {
    qsa('[data-carousel]').forEach((wrap) => {
      if (wrap._init) return;
      const track = qs('[data-carousel-track]', wrap);
      const prev = qs('[data-carousel-prev]', wrap);
      const next = qs('[data-carousel-next]', wrap);
      if (!track || !prev || !next) return;
      wrap._init = true;
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max - 2;
        const scrollable = max > 2;
        prev.hidden = !scrollable;
        next.hidden = !scrollable;
      };
      const step = (dir) => track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' });
      prev.addEventListener('click', () => step(-1));
      next.addEventListener('click', () => step(1));
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Offer countdown (only when the merchant sets a real end date) ---------- */
  function initCountdowns() {
    qsa('[data-countdown]').forEach((el) => {
      if (el._init) return;
      const end = new Date(el.getAttribute('data-countdown').replace(' ', 'T'));
      if (isNaN(end.getTime())) return;
      el._init = true;
      const label = el.getAttribute('data-label') || '';
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        const ms = end.getTime() - Date.now();
        if (ms <= 0) {
          const box = el.closest('.product__offer');
          if (box) box.hidden = true;
          return false;
        }
        const d = Math.floor(ms / 864e5);
        const h = Math.floor((ms % 864e5) / 36e5);
        const m = Math.floor((ms % 36e5) / 6e4);
        const sec = Math.floor((ms % 6e4) / 1e3);
        el.textContent = label + ' ' + (d ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(sec);
        return true;
      };
      if (tick()) setInterval(tick, 1000);
    });
  }

  /* ---------- Ebook preview: tabs, page slider, lightbox ---------- */
  let lb = null;
  function lbRender() {
    const el = lb.group[lb.i];
    qs('img', lb.box).src = el.getAttribute('data-zoom');
    qs('figcaption', lb.box).textContent = el.getAttribute('data-caption') || '';
    qs('[data-lb-prev]', lb.box).hidden = lb.group.length < 2;
    qs('[data-lb-next]', lb.box).hidden = lb.group.length < 2;
  }
  function lbStep(dir) {
    if (!lb) return;
    lb.i = (lb.i + dir + lb.group.length) % lb.group.length;
    lbRender();
  }
  function closeLightbox() {
    if (!lb || lb.box.hidden) return;
    lb.box.hidden = true;
    document.documentElement.classList.remove('no-scroll');
    if (lb.opener && lb.opener.focus) lb.opener.focus();
  }
  function openLightbox(btn) {
    const track = btn.closest('[data-look-track]');
    if (!track) return;
    let box = qs('[data-lightbox]');
    if (!box) {
      box = document.createElement('div');
      box.className = 'lightbox';
      box.setAttribute('data-lightbox', '');
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'true');
      box.hidden = true;
      box.innerHTML = '<button type="button" class="lightbox__close" data-lb-close aria-label="' + (S.close || 'Close') + '">&times;</button>' +
        '<button type="button" class="lightbox__nav lightbox__nav--prev" data-lb-prev aria-label="' + (S.previous || 'Previous') + '">&lsaquo;</button>' +
        '<figure><img alt=""><figcaption></figcaption></figure>' +
        '<button type="button" class="lightbox__nav lightbox__nav--next" data-lb-next aria-label="' + (S.next || 'Next') + '">&rsaquo;</button>';
      document.body.appendChild(box);
      box.addEventListener('click', (e) => {
        if (e.target === box || e.target.closest('[data-lb-close]')) closeLightbox();
        else if (e.target.closest('[data-lb-prev]')) lbStep(-1);
        else if (e.target.closest('[data-lb-next]')) lbStep(1);
      });
    }
    const group = qsa('[data-zoom]', track);
    lb = { box: box, group: group, i: group.indexOf(btn), opener: btn };
    lbRender();
    box.hidden = false;
    document.documentElement.classList.add('no-scroll');
    qs('[data-lb-close]', box).focus();
  }
  document.addEventListener('click', (e) => {
    const z = e.target.closest && e.target.closest('[data-zoom]');
    if (z) openLightbox(z);
  });
  document.addEventListener('keydown', (e) => {
    if (!lb || lb.box.hidden) return;
    if (e.key === 'Escape') closeLightbox();
    else if (e.key === 'ArrowLeft') lbStep(-1);
    else if (e.key === 'ArrowRight') lbStep(1);
  });

  function initLookInside() {
    qsa('[data-lookinside]').forEach((root) => {
      if (root._init) return;
      root._init = true;
      const tabs = qsa('[data-look-tab]', root);
      const panels = qsa('[data-look-panel]', root);
      const sync = (panel) => {
        const track = qs('[data-look-track]', panel);
        const prev = qs('[data-look-prev]', panel);
        const next = qs('[data-look-next]', panel);
        if (!track || !prev || !next) return;
        const max = track.scrollWidth - track.clientWidth;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max - 2;
        prev.hidden = next.hidden = !(max > 2);
      };
      panels.forEach((panel) => {
        const track = qs('[data-look-track]', panel);
        const step = (dir) => track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
        qs('[data-look-prev]', panel).addEventListener('click', () => step(-1));
        qs('[data-look-next]', panel).addEventListener('click', () => step(1));
        track.addEventListener('scroll', () => sync(panel), { passive: true });
      });
      const show = (id) => {
        tabs.forEach((t) => {
          const on = t.getAttribute('data-look-tab') === id;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        panels.forEach((p) => {
          p.hidden = p.getAttribute('data-look-panel') !== id;
          if (!p.hidden) {
            const tr = qs('[data-look-track]', p);
            if (tr) tr.scrollLeft = 0;
            sync(p);
          }
        });
      };
      tabs.forEach((t, i) => {
        t.addEventListener('click', () => show(t.getAttribute('data-look-tab')));
        t.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          const n = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
          n.focus();
          show(n.getAttribute('data-look-tab'));
        });
      });
      window.addEventListener('resize', () => panels.forEach((p) => { if (!p.hidden) sync(p); }));
      show(tabs.length ? tabs[0].getAttribute('data-look-tab') : '');
    });
  }

  /* ---------- Sale timer widget ---------- */
  function initTimers() {
    qsa('[data-timer]').forEach((el) => {
      if (el._init) return;
      el._init = true;
      const mode = el.getAttribute('data-mode');
      const action = el.getAttribute('data-action') || 'message';
      const duration = (Number(el.getAttribute('data-duration')) || 0) * 6e4;
      const designMode = !!(window.Shopify && window.Shopify.designMode);
      const host = el.closest('.announcement__item') || el;
      const clock = qs('[data-timer-clock]', el);
      const endedEl = qs('[data-timer-ended]', el);
      const beforeEl = qs('[data-timer-before]', el);
      const hintEl = qs('[data-timer-hint]', el);
      const unitEls = qsa('[data-unit]', el);
      const nums = { d: qs('[data-t="d"]', el), h: qs('[data-t="h"]', el), m: qs('[data-t="m"]', el), s: qs('[data-t="s"]', el) };
      const pad = (n) => String(n).padStart(2, '0');
      const parse = (v) => { const t = new Date(v || '').getTime(); return isNaN(t) ? null : t; };
      const storageKey = 'timer:' + (el.getAttribute('data-key') || 'default');
      const totalHours = el.hasAttribute('data-total-hours');

      let start = null;
      let end = null;
      if (mode === 'visitor') {
        let saved = 0;
        try { saved = Number(window.localStorage.getItem(storageKey)) || 0; } catch (err) { saved = 0; }
        if (!saved) {
          saved = Date.now();
          try { window.localStorage.setItem(storageKey, String(saved)); } catch (err) { /* private mode */ }
        }
        start = saved;
        end = saved + duration;
      } else if (mode === 'end') {
        end = parse(el.getAttribute('data-end'));
      } else {
        start = parse(el.getAttribute('data-start'));
        end = start === null ? null : start + duration;
      }

      if (end === null) {
        if (designMode && hintEl) { clock.hidden = true; hintEl.hidden = false; el.classList.add('is-ready'); } else { host.hidden = true; }
        return;
      }

      // The hours box only appears when the timer is at least one hour long.
      const now0 = Date.now();
      let span = mode === 'end' ? end - now0 : duration;
      if (start !== null && start > now0) span = Math.max(span, start - now0);
      const showHours = span >= 36e5;

      let timerId = null;
      const stop = () => { if (timerId) clearInterval(timerId); timerId = null; };
      const finish = () => {
        stop();
        if (action === 'hide' && !designMode) {
          host.hidden = true;
        } else {
          clock.hidden = true;
          if (beforeEl) beforeEl.hidden = true;
          if (endedEl) endedEl.hidden = false;
          host.classList.add('is-ended');
          el.classList.add('is-ready');
        }
        host.dispatchEvent(new CustomEvent('timer:end', { bubbles: true }));
      };

      const tick = () => {
        if (!el.isConnected) { stop(); return; }
        const now = Date.now();
        let remaining;
        if (start !== null && now < start) {
          remaining = start - now;
          if (beforeEl) { beforeEl.textContent = el.getAttribute('data-before') || ''; beforeEl.hidden = !beforeEl.textContent || el.classList.contains('timer--bar'); }
        } else {
          if (beforeEl) beforeEl.hidden = true;
          remaining = end - now;
          if (remaining <= 0) {
            if (mode === 'visitor' && action === 'restart') {
              start = now;
              end = now + duration;
              try { window.localStorage.setItem(storageKey, String(start)); } catch (err) { /* private mode */ }
              remaining = duration;
            } else {
              finish();
              return;
            }
          }
        }
        const total = Math.floor(remaining / 1000);
        const d = totalHours ? 0 : Math.floor(total / 86400);
        let hours = 0;
        let minutes = Math.floor((total % 3600) / 60);
        if (showHours) hours = totalHours ? Math.floor(total / 3600) : Math.floor((total % 86400) / 3600);
        else minutes = Math.min(99, Math.floor(total / 60));
        nums.d.textContent = pad(d);
        nums.h.textContent = pad(hours);
        nums.m.textContent = pad(minutes);
        nums.s.textContent = pad(total % 60);
        const hide = { d: d === 0, h: !showHours, m: false, s: false };
        let firstSet = false;
        unitEls.forEach((u) => {
          const off = hide[u.getAttribute('data-unit')];
          u.hidden = off;
          const isFirst = !off && !firstSet;
          if (isFirst) firstSet = true;
          u.classList.toggle('is-first', isFirst);
        });
        el.classList.add('is-ready');
      };

      tick();
      if (el.isConnected && !host.hidden && !clock.hidden) timerId = setInterval(tick, 1000);
    });
  }

  /* ---------- Daily cutoff countdown ---------- */
  function initCutoffs() {
    qsa('[data-cutoff]').forEach((el) => {
      if (el._init) return;
      el._init = true;
      const timeEl = qs('[data-cutoff-time]', el);
      let cutoff = new Date(el.getAttribute('data-cutoff') || '').getTime();
      if (isNaN(cutoff) || !timeEl) { if (!(window.Shopify && window.Shopify.designMode)) el.hidden = true; return; }
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        if (!el.isConnected) { clearInterval(id); return; }
        const now = Date.now();
        while (cutoff <= now) cutoff += 864e5;
        const total = Math.floor((cutoff - now) / 1000);
        timeEl.textContent = pad(Math.floor(total / 3600)) + ':' + pad(Math.floor((total % 3600) / 60)) + ':' + pad(total % 60);
      };
      const id = setInterval(tick, 1000);
      tick();
    });
  }

  /* ---------- Product tabs ---------- */
  function initTabs() {
    qsa('[data-tabs]').forEach((root) => {
      if (root._init) return;
      root._init = true;
      const tabs = qsa('[data-tab]', root);
      const panels = qsa('[data-tab-panel]', root);
      if (!tabs.length || tabs.length !== panels.length) return;
      root.classList.add('is-enhanced');
      const show = (idx, focus) => {
        tabs.forEach((t, i) => {
          const on = i === idx;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          panels[i].classList.toggle('is-active', on);
        });
        if (focus) tabs[idx].focus();
      };
      tabs.forEach((t, i) => {
        t.addEventListener('click', () => show(i, false));
        t.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') { e.preventDefault(); show((i + 1) % tabs.length, true); }
          else if (e.key === 'ArrowLeft') { e.preventDefault(); show((i - 1 + tabs.length) % tabs.length, true); }
        });
      });
      show(0, false);
    });
  }

  /* ---------- Promo strip stuck to the bottom: keep the page from being covered ---------- */
  function initPromoStrips() {
    qsa('[data-promo-strip]').forEach((bar) => {
      const spacer = bar.parentElement && qs('[data-promo-spacer]', bar.parentElement);
      if (!spacer || bar._init) return;
      bar._init = true;
      const sync = () => { spacer.style.height = bar.offsetHeight + 'px'; };
      sync();
      window.addEventListener('resize', sync);
      if (window.ResizeObserver) new ResizeObserver(sync).observe(bar);
    });
  }

  /* ---------- Boot ---------- */
  function init() {
    initHeader();
    initTimers();
    initAnnouncement();
    initReviewsLink();
    qsa('[data-product-section]').forEach(initProduct);
    initRecommendations();
    initCarousels();
    initCountdowns();
    initCutoffs();
    initTabs();
    initPromoStrips();
    initLookInside();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme editor: re-init after sections are re-rendered.
  document.addEventListener('shopify:section:load', init);

  // Back/forward cache: keep cart count fresh.
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) {
      fetch(R.root + '?sections=cart-drawer', { headers: { Accept: 'application/json' } })
        .then((res) => res.json())
        .then((data) => {
          const doc = new DOMParser().parseFromString(data['cart-drawer'] || '', 'text/html');
          const inner = qs('[data-cart-drawer-inner]', doc);
          if (inner) updateCount(Number(inner.getAttribute('data-item-count')) || 0);
        })
        .catch(() => {});
    }
  });
})();
